// CHINESE LANGUAGE RESOURCES
const RESOURCES = {
  WEBSITE: "RoboMaster官网",
  BBS: "RoboMaster论坛",
  CHANGE: "更换",
  DETAIL: "详情",
  STATUS: "状态",
  CONFIRM: "确定",
  CANCEL: "取消",
  NOTIFICATION: "通知",
  EDIT: "编辑",
  CANCEL_EDIT: "完成编辑",
  CHANGE_CHINESE: "中文",
  CHANGE_ENGLISH: "English",
  REGISTRATION_CENTER: "报名中心",
  RETURN_REGISTRATION_CENTER: "返回报名中心",
  YOU_WILL_JOIN_IN: " 您即将加入的是",
  JOIN_IN: "参加",
  CONTROL_CENTER: "管理中心",
  RETURN_CONTROL_CENTER: "返回管理中心",
  MY_TEAMS: "参加活动",
  MY_GAMES: "参加比赛",
  EDIT_INFO: "编辑资料",
  REGISTRATION_TIME_REMAINING: "报名剩余时间",
  REGISTRATION_TIME_BEGIN: "报名开始时间",
  APPLY_NOW: "立即报名",
  GAME_TIME: "比赛时间：",
  NEXT: "下一步",
  COMPLETE_INFO: "去完善",
  PERSON_INFO_NOT_COMPLETE: "个人资料未完善",
  PERSION_NOTICE: "请先完善个人资料方能报名",
  WORK_NOTICE: "指导老师需完善个人资料中的【工作信息】，方可加入战队",
  CREATE_TEAM: "创建战队",
  CREATE_TEAM_SUCCESS: "创建成功",
  CREATE_TEAM_DESC: "创建一个战队，成为队长，招募队员，创造属于你们的辉煌",
  CREATE_TEAM_INFO: "如果您是战队队长，请先创建战队",
  JOIN_IN_TEAM: "加入战队",
  JOIN_A_TEAM: "加入战队",
  JOIN_A_DELIVERY: "立即投递",
  CONFIRM_THE_ENTRY_INFO: "请确认参赛信息",
  CONFIRM_THE_ENTRY_INFO_TIPS:
    "请提供准确的个人信息用于证书制作和现场查验，若信息不符将影响参赛资格",
  COMPETITION: "比赛",
  INVITATION_CODE_INFO: "邀请码请咨询您想要加入的战队队长",
  ENTER_INVITATION: "输入邀请码",
  TEAM_NAME: "战队名称",
  TEAM_NAME_EN: "战队名称（英文）",
  TEAM_NAME_EN_TIP: "英文奖状/国际宣传场景使用需要",
  GROUP_TYPE: "队伍类型",
  TEAM_SCHOOL: "代表学校",
  CAMPUS_ORGANIZATION: "所属校内机构",
  INTRODUCTIONLINK: "介绍链接",
  CAMPUS_ORGANIZATION_TIP: "队伍所属校内机构或二级教学科研单位，如工训中心/创新中心/所在学院等",
  INTRODUCTION_LINKS: "介绍链接",
  INTRODUCTION_LINKS_TIP:
    "请填写机构介绍的链接，以https://或http://作为前缀，后期将会在榜单上对外展示。",
  ADDRESSEE: "收件人",
  ADDRESSEE_PHONE: "联系方式",
  ADDRESSEE_ADRESS: "收件地址",
  YOUR_POSITION: "您的职位",
  POSITION: "职位",
  YOUR_ROLE: "您的角色",
  ROLE: "角色",
  YOUR_APPLY: "您已申请加入",
  APPLY_SUCCESS: "申请成功",
  YOU_CAN: "您可以在",
  YOU_CAN2: "您可以在",
  VIEW_PROCESS: "查看进度",
  YOUR_ALSO: "也可以",
  CANCEL_APPLY: "撤销申请",
  YOU_APPLYED: "您已经创建了",
  YOU_INVITATION_CODE: "战队邀请码",
  CREATE_TEAM_SUCCESS_TIP: "您的队员现在可以通过",
  CREATE_TEAM_SUCCESS_TIP2:
    "网站注册自己的信息，并在报名中心使用这个邀请码，就可以快速加入您的战队。请注意保密您战队的邀请码。",
  CANTROL_YOUR_TEAM: "管理你的战队信息",
  GAME_CONTROL: "比赛管理",
  GAME_TYPE: "比赛类型",
  CAPTAIN: "队长",
  MY_POSITION: "我的职位",
  VIEW: "查看",
  ENTRY_PROJECT: "参赛项目",
  ENTRY_PROJECT_EMPTY_TIP: "参赛项目不能为空",
  PLEASE_ENTER_CAMPUS_ORGANIZATION: "所属校内机构不能为空",
  CHANGE_INVITATION_CODE: "更换邀请码",
  APPLY_GAME: "确认报名",
  TEAM_MEMBERS: "队伍成员",
  CURRENT_SCHOOL: "就读学校",
  START_YEARL: "入学年份",
  MAJOR: "专业",
  KICK_OUT: "踢出",
  TEACHER: "指导老师",
  ADVISER: "顾问",
  PROJECT_MANAGER: "项目管理",
  PROMOTION_MANAGER: "宣传经理",
  TEAM_MEMBER: "队员",
  INVITATION_TIP: "原先的邀请码会立刻失效",
  DETAIL_INFO: "详细信息>",
  PACK_UP: "收起",
  PASS: "通过",
  PASSED: "通过",
  UPLOAD_HISTORY: "上传记录",
  VIEW_MORE: "..了解更多",
  ADDRESSEE_TIP: "路名或街道地址，门牌号，非国内地址请填写邮编",
  SCHOOL_NAME: "学校名称",
  SCHOOL_NAME_SHORT: "学校简称",
  SCHOOL_NAME_EMPTY_TIP: "学校名称不能为空",
  SCHOOL_NAME_AREA: "所在地区",
  SCHOOL_NAME_AREA_EMPTY_TIP: "所在地区不能为空",
  SCHOOL_TIP: "输入并在匹配项中选择",
  CREATE_TEAM_LOGO_TIP: "800*800px，透明底png格式",
  CREATE_TEAM_LOGO_TIP_SIZE: "图片尺寸不符合要求，请重新上传",
  CREATE_TEAM_LOGO_TIP_ERROR: "上传失败，请重新上传",
  CREATE_TEAM_LOGO_TIP_TYPE: "图片类型不符合要求，请重新上传",
  CREATE_TEAM_LOGO_TIP_LARGE: "图片大小不符合要求，请重新上传",
  TEAM_LOGO_EMPTY_TIP: "学校校徽不能为空",
  TEAM_IS_LOCKED: "战队已锁定",
  AGREE_TERMS: "我已阅读并同意上述条款",
  TEAM: "战队",
  CONSORTIUM: "联队",
  INVALID_INVITATION_CODE: "无效的邀请码，请和您想加入战队的队长确认",
  WRONG_INVITATION_CODE: "该邀请码为{key-0}比赛邀请码，请前往{key-0}比赛进行报名。",
  IS_END: "已结束",
  PLEASE_ENTER_TEAM_NAME: "战队名称不能为空",
  PLEASE_ENTER_TEAM_NAME_EN: "战队名称（英文）不能为空",
  WRONG_PHONE: "请输入正确的手机号",
  EMPTY_PHONE: "联系方式不能为空",
  TEAM_SCHOOL_EMPTY_TIP: "代表学校不能为空",
  TEAM_NAME_TIP:
    "不得超过16个字符(每个汉字计2个字符，每个英文字母计1个字符)，不可包含校名、校名简称、校名英文简称、“队”“团队”“战队”等字眼或“*/-+”等特殊符号",
  TEAM_ABBREVIATION_TIP: "不得超过16个字符(每个汉字计2个字符，每个英文字母计1个字符)",
  EMPTY_RECIPIENT: "收件人不能为空",
  EMPTY_ADDRESS: "收件地址不能为空",
  OTHER_SCHOOL: "找不到自己的学校？",
  EMPTY_SCHOOL_SHORT: "学校简称不能为空",
  REGISTRATION: "报名人员",
  REJECT: "拒绝",
  APPLICANT_LIST: "申请列表",
  APPLICANT_LIST_NUM: "申请列表 ({key-0})",
  EDIT_TEAM_INFO: "更新信息",
  COLLEGES_INFO: "学校信息",
  UPDATE_TEAM: "更新",
  NOT_BEGIN: "尚未开始",
  COMFIRM_CANCEL: "确定撤销申请？",
  COMFIRM_CANCEL_DETAIL: "撤销后，战队将无法收到您的入队申请。",
  LOCKED: "已锁定",
  UNLOCKED: "未锁定",
  TEAM_GAME: "团体赛",
  PERSON_GAME: "个人赛",
  TEAM_LOCK_DESC1: "已报名",
  TEAM_LOCK_DESC2:
    "比赛，队员资料已被锁定，无法修改。备赛期间，战队及成员资料将定期开放，具体开放时间请留意官方公告。",
  TEAMMEMBER_LIST: "队员列表",
  TEAMMEMBER_LIST_NUM: "队员列表 ({key-0})",
  EXIT_TEAM: "退出战队",
  NOW_MEMBER_NUM: "当前人数",
  CONFIRM_TIP:
    "提交报名后，战队资料和队员资料不得修改，备赛期间，战队及成员资料将定期开放，具体开放时间请留意官方公告。",
  MEMBER_INVALID: "请检查成员的信息是否完整，成员的信息填写完整后方能提交。",
  CONFIRM_MEMBER_TIP_TITLE: "信息确认后不可更改",
  CONFIRM_MEMBER_TIP: "战队信息将用于后续比赛直播呈现、证书制作，点击确认后信息将不可更改。",
  CONFIRM_MEMBER_WARN: "注意：所有改动立即生效，但组委会将以最终提交版为审核依据，请及时提交。",
  CONFIRM_SUBMIT: "报名确认",
  SHOW_ALL_MEMBERS: "查看全部队员",
  REGISTRATION_CODE_GET: "获得报名号",
  CHANGE_CAPTAIN: "更换队长",
  CHANGE_CAPTAIN_TIP: "更换队长后，您的身份从“战队队长”更改为“战队队员”，并且无管理权限更换。",
  DELETE_TEAM: "解散战队",
  DELETE_TEAM_TIP: "所有战队信息将不会被保存，这是不可逆的操作。",
  DELETE_TEAM_CONFIRM: "我知道了",
  TEAM_MEMBER_MISSING_TITLE: "战队资料不符合报名要求",
  TEAM_MEMBER_REQUIRED: "报名要求:",
  TEAM_MEMBER_REQUIRED_1: "1、战队资料完善；",
  SELECT_FILE: "选取文件",
  REGISTRATION_CODE: "报名号",
  ENGLISH_NAME: "英文名",
  FAIL: " 不通过",
  FAILED: " 未通过",
  INVALID_CHAR: "无效字符",
  MUST_BE_CAP: "首字母必须大写",
  CHAR_LIMIT: "超过字符限制",
  ILLEG_CHAR: "包含非法字符",
  SUBMIT_LIMIT: "提交次数已达上限",
  SUBMIT_LIMIT_CUR: "当日提交次数已达上限",
  FILE_SIZE_LIMIT: "文件大小超过限制",
  UPDATE_SUCCESS: "报名成功！",
  ENTTRY_TEAM: "参赛条款",
  RECRUITMENT_INSTRUCTIONS: "招聘说明",
  ENTER_INVITATION_TIP: "请输入邀请码",
  CONFIRM_SUBMIT_FORM: "确认提交？",
  WELCOME: "欢迎",
  PERSON_CENTER: "个人中心",
  CHANGE_PASSWORD: "修改密码",
  LOGOUT: "登出",
  LOGIN: "登录",
  REGISTER: "注册",
  // PREPARATION_COMPLETE: "备赛完成",
  // PREPARATION_COMPLETE_TIP1: "恭喜您顺利完成备赛流程，祝您的战队在",
  // PREPARATION_COMPLETE_TIP2: "中取得好成绩！",
  RETURN_GAME_APPLY: "返回上一页",
  IS_COMPLETED: "已完成备赛，祝比赛顺利！",
  FINAL_REGION: "最终赛区",
  MESSAGE_CENTER: "消息中心",
  IS_CLOSED: "已关闭",
  LAST_TIME: "最近一次提交",
  EXAM_STATUS: "测评状态",
  EXAM_STATUS_TIP:
    "根据最终测评成绩（规则测评环节结束时的最新测评结果）进行判定；测评最终结果将于2018年11月7号14:00前公布",
  CANNOT_THE_SAME: "第一志愿与第二志愿赛区不得重复",
  START_EVALUATION: "开始测评",
  IS_REQUIRED: "请提交{key-0}",
  IS_REQUIRED_INPUT: "{key-0}不可为空",
  COPY_TEAM: "复制历史战队信息",
  COPY_TEAM_TIP: "以下是你参加过的全部战队信息，请选择要复制的战队",
  JUAGE_SCORE_LAST: "测评状态：根据最终测评成绩（规则测评环节结束时的最新测评分数）进行判定",
  JUAGE_SCORE_HIGHEST: "测评状态： 根据最终测评成绩（规则测评环节结束时的历史最高分）进行判定。",
  EVENTS_CONTROL: "活动管理",
  EVENTS_NAME: "活动名称",
  CURRENT_STAGE: "当前环节",
  CURRENT_STATUS: "当前状态",
  ABNORMAL_DATA: "数据异常",
  SUBMIT: "提交资料",
  MEETING_IS_FULL: "(人满)",
  CHOOSE_DATE: "选择日期",
  CHOOSE_TIME: "选择时间",
  RESERVATION_TIME: "预约时间",
  INTERVIEW_TIME: "面试时间",
  INTERVIEW_DATE_REQUIRE: "面试日期不能为空",
  INTERVIEW_TIME_REQUIRE: "面试时间不能为空",
  CONFIRM_SUBMIT_MEETING: "请确认是否提交面试时间，提交后将无法修改面试时间。",
  ADD_UNITED_SCHOOL: "添加战队学校",
  AREA: "国家/省份/城市/区县",
  ADD_UNITED_SCHOOL_TIP: "注意： 至多可以添加5个学校",
  KICK_OUT_TITLE: "确定要踢出此人吗？",
  KICK_OUT_TIP: "踢出后将无法恢复操作。若要重新加入战队，需队员在有效报名时段内重新提交入队申请。",
  KICK_OUT_CONFIRM: "确定",
  KICK_OUT_CANCEL: "取消",
  USER_TITLE: "User",
  XP_TITLE: "Experience",
  AGE_TITLE: "Age",
  APP_DESCRIPTION: "React Create App with React Router and MobX and Internationalization.",
  ACTIONS: {
    INCREASE_XP: "Increase Experience Points!",
    CHANGE_NAME: "Change My Name!",
    CHANGE_LASTNAME: "Change My Last Name!"
  },
  MUTI_SCORE: "成绩",
  MUTI_SUBMIT_TIME: "提交时间",
  MUTI_STATUS: "测评状态",
  MUTI_END_TIME: "距离本轮测评还剩",
  MUTI_PENDING_STATUS: "查询中，请刷新页面获取",
  MUTI_ERROR: "当前服务器正忙，请稍后再试",
  SERVER_ERROR_NEED_LOGIN:
    "您的登录状态已过期，报名未成功。可能是您在其他窗口登录了相同的账号，将为您刷新页面，请在刷新后重新报名。",
  SERVER_ERROR_VALIDATE_FAILED:
    "您的登录状态已过期，报名未成功。可能是您在其他窗口登录了其他账号，将为您刷新页面，请检查您的账户。",
  AUTHORISATION_TITLE: "管理权限",
  AUTHORISATION_NOTICE:
    "您可以授予队伍中的一人协助管理队伍。\n此人可以修改战队资料、解散战队、更换邀请码、修改队员角色、修改队员职位、踢出队员、可以管理队员入队申请以及报名参赛并有权限提交报名流程中各个环节的资料（测评环节除外）。\n您也可以取消此人的管理权限。",
  AUTHORISATION_DIALOG_TITLE: "确定要授予此人管理权限吗？",
  AUTHORISATION_DIALOG_DESC:
    "每个队伍中只能授予一人该权限。授权后该队员将具备队伍管理权限。您也可以取消。",
  AUTHORISATION_DIALOG_CONFIRM: "确定",
  AUTHORISATION_DIALOG_CANCEL: "取消",
  AUTHORISATION_FAILED: "授权失败，请重试。",
  AUTHORIZE: "授予",
  AUTHORISE_CANCEL: "取消授权",
  COMPLETE_PROMPT_MESSAGE:
    "参加机甲大师对抗赛、单项赛、人工智能挑战赛的参赛队员，请下载并仔细阅读报名指引。",
  // COMPLETE_PROMPT_MESSAGE_SECOND: '参加机甲大师青少年系列赛的队伍指导老师，请下载并仔细阅读报名指引二。',
  PROMPT_MESSAGE: "参加机甲大师高校系列赛的参赛队员，请下载并仔细阅读",
  REGISTRATION_GUIDELINES: "报名指引一",
  PROMPT_MESSAGE_SECOND: "参加机甲大师青少年系列赛的队伍指导老师，请下载并仔细阅读",
  REGISTRATION_GUIDELINES_SECOND: "报名指引二",
  PERIOD: ";",
  PERIOD_SECOND: "。",
  LOADING: "加载中...",
  DOCKER_UPLOAD: "文件上传中，请稍等...",
  DOCKER_UPLOAD_SUCCEED: "上传成功",
  DOCKER_UPLOAD_FAILED: "上传失败",
  DOCKER_UPLOAD_SUCCEED_INFO: "程序已进入执行队列，可在提交记录中查看结果",
  DOCKER_UPLOAD_CANCEL: "取消上传",
  DOCKER_UPLOAD_AGAIN: "重新上传",
  DOCKER_UPLOAD_INFO_1: `若当前程序执行状态为“优先队列 排队中”或“普通队列 排队中”，重新上传将会导致该状态变更为“已取消”，新上传的程序会重新进入排队序列。`,
  DOCKER_UPLOAD_INFO_2: `请保持网页稳定，若意外中断上传，可重新选择同一个文件重新提交，原上传进度不会丢失。`,
  IS_CANCEL_UPLOAD_DOCKER: "请确认是否要取消上传。",
  CLOSE: "关闭",
  DOCKER_UPLOAD_FAILED_INFO: "失败原因：{key-0}",
  TEAM_INFO: "基础信息",
  PERSONAL_INFO_NOT_CHECKED: "信息校验不通过",
  UPDATE_PERSONAL_INFO: "点击前往个人中心修改",
  PERSONAL_INFO_VERFICATION_FAILED: "您的信息不符合校验规则",
  CHANGE_PERSONAL_INFO: "修改个人信息",
  PERSONAL_INFO_ALERT:
    "最高学历数据来源于个人中心，更新后同步更新至个人中心，为确保流程正常推进，请确保信息准确。",
  NAME: "姓名",
  CHINESE_NAME: "中文名",
  PHONE_NUMBER: "手机号",
  EMAIL: "邮箱",
  H_EDUCATION: "最高学历",
  H_SCHOOL: "最高学历学校",
  H_COLLEGE: "最高学历学院",
  H_MAJOR: "最高学历专业",
  H_START_TIME: "最高学历开始时间",
  H_END_TIME: "最高学历结束时间",
  ENTER: "请输入",
  SELECT: "请选择",
  WRONG_EMAIL: "请输入正确的邮箱",
  CLICK_TO_LOAD_MORE: "点击加载更多记录",
  CLICK_TO_CLOSE: "点击收起",
  CLICK_TO_UPDATE_PERSONAL_INFO: "点击更新个人信息",
  BACK: "返回",
  CONFIRM_INFO_IS_OK: "我承诺信息无误",
  H_EDUCATION_ERROR_TIPS_0: "本科经历时间小于4年，请确认学历时间是否正确",
  H_EDUCATION_ERROR_TIPS_1: "本科经历时间大于4年，请确认学历时间是否正确",
  H_EDUCATION_ERROR_TIPS_2: "硕士经历持续时间大于3年，请确认学历时间是否正确",
  H_EDUCATION_ERROR_TIPS_3: "硕士经历持续时间为0年，请确认学历时间是否正确",
  H_EDUCATION_ERROR_TIPS_4: "博士经历持续时间大于6年，请确认学历时间是否正确",
  H_EDUCATION_ERROR_TIPS_5: "博士经历持续时间小于3年，请确认学历时间是否正确",
  SCHOOL_FULL_NAME_ZH: "学校中文全称",
  SCHOOL_SHORT_NAME_ZH: "学校中文简称",
  SCHOOL_FULL_NAME_EN: "学校英文全称",
  SCHOOL_SHORT_NAME_EN: "学校英文简称",
  SCHOOL_ADDRESS: "国家/省份/城市",
  SCHOOL_COUNTRY: "学校国家",
  UPDATE_SCHOOL_INFO: "更新学校信息",
  SCHOOL_FULL_NAME_CAN_NOT_EMPTY: "学校中英文全称不可全为空",
  SCHOOL_SHORT_NAME_ZH_LIMIT: "请控制在8个汉字以内",
  SCHOOL_SHORT_NAME_EN_LIMIT: "请控制在16个英文字母以内",
  COUNTRY: "国家",
  SAVE: "保存",
  SCHOOL_BADGE: "校徽",
  CLICK_TO_SELECT_FILE: "点击选择文件",
  UPLOAD_SCHOOL_BADGE_TIPS: "限制1MB内，尺寸为800 * 800px的.png透明背景文件",
  SCHOOL_BADGE_FORMATS: "格式",
  SCHOOL_BADGE_LARGE: "大小",
  SCHOOL_BADGE_SIZE: "尺寸",
  SCHOOL_BADGE_FETCH_ERROR: "获取校徽失败，请刷新页面重试。",
  SCHOOL_BADGE_ERROR: "校徽不符合要求，请重新上传。",
  UPDATE_SCHOOL_INFO_ERROR: "保存学校信息失败，请刷新页面重试。",
  UPDATE_SCHOOL_INFO_ERROR_EXISTING: "保存学校信息失败，学校已存在。",
  UPDATE_SCHOOL_INFO_SUC: "更新学校信息成功。",
  VERIFY_SCHOOL_BADGE_FORMATS: "学校校徽文件格式非png，请更新学校信息",
  VERIFY_SCHOOL_BADGE_LARGE: "学校校徽文件大小大于1MB，请更新学校信息",
  VERIFY_SCHOOL_BADGE_SIZE: "学校校徽文件尺寸非800px * 800px，请更新学校信息",
  CONFIRM_INFO: "确认信息",
  TEAM_INFO_NOT_CONFIRMED: "战队资料未确认",
  TEAM_INFO_NOT_CONFIRMED_DETAILS: "请确认战队信息、学校信息和队员信息，点击确认信息后继续环节操作",
  ADD_SCHOOL_INFO: "添加学校",
  ADD_SCHOOL_INFO_ERROR: "添加学校失败，请稍后重试。",
  ADD_SCHOOL_INFO_ERROR_EXISTING: "添加学校失败，学校已存在。",
  TEAM_SLOGAN: "战队口号",
  TEAM_SLOGAN_TIPS:
    "请采用积极正向，能够突出战队文化的口号，战队口号将用于后续比赛直播及相关的活动使用。",
  UPDATE_PERSONAL_INFO_CONFIM_TIPS:
    "你正在更新你的学校信息，该信息将用于后续比赛直播呈现及获奖证书制作，点击确认后信息将不可更改，请谨慎操作。",
  SELECT_TEAM: "选择参赛队伍",
  SELECT_TEAM_TIPS: "选择后此队伍将参与 {key-0}",
  CONFIRM_REGISTRATION_INFO: "确认报名信息",
  CREATE_TEAM_BBS_TIPS1: "信息确认后将完成本赛季报名，战队信息",
  CREATE_TEAM_BBS_TIPS2: "本赛季不支持修改",
  CREATE_TEAM_BBS_TIPS3: "，请谨慎操作。具体参赛名单将在后续环节中收取，请留意赛事公告及通知。",
  APPLY_TIPS_BBS:
    "请联系战队队长或指导老师报名，或联系 RoboMaster 高校赛务获取参赛指南。（微信号：rmsaiwu）",
  ENTRY_LIST_TIPS: "*参赛名单后续收集，请留意通知。",
  PLEASE_ENTER_TEAM_SLOGAN: "战队口号不能为空",
  WRONG_TEAM_SLOGAN: "请输入正确的战队口号",
  TEAM_SLOGAN_TOOL_TIP_TEXT:
    "战队口号最多不超过40字符。其中中文计2字符，中文标点计2字符，小写英文字母计2字符，大写英文字母计2字符，英文标点计1字符，空格计1字符。",
  CONFIRM_TEAM_INFO: "确认参赛信息",
  SUBMIT_ENTRY_LIST: "提交正式队员、老师及顾问名单",
  SUBMIT_RESERVE_LIST: "提交梯队队员名单",
  COLLECTION_LIST_NEXT_TIPS:
    "注意：需点击下一步并提交参赛名单后组委会将会审核参赛名单，最终是否成功参赛请留意官网公告",
  ENTRY_LIST: "参赛名单",
  DIRECTION: "方向",
  NO_DATA: "暂无内容"
};

export default RESOURCES;



// WEBPACK FOOTER //
// ./src/language/i18n/zh.js